import { IResponseHeaderView } from 'v2/resources/types/headerView';
import { DEFAULT_RESPONSE_HEADER_VIEW } from './types';
import api from 'services/api';
import { HttpCodes } from 'v2/resources/types/httpCode';

export const HeaderViewServices = {
  getHeaderView: async (): Promise<IResponseHeaderView> => {
    const response = await api.get<IResponseHeaderView>(
      '/dashboard/headerView'
    );

    if (response.status === HttpCodes.SUCCESS) {
      return response.data;
    }
    return DEFAULT_RESPONSE_HEADER_VIEW;
  },
};
